<template>
  <entity-edit-form
    :title="title"
    :data-service="dataService"
    :create-entity="isCreate"
    :fields="fields"
    :list-route-name="listRouteName"
    :item-id="this.$route.params.id"
    @entity-created="afterCreate"
  >
  </entity-edit-form>
</template>

<script>
  import EntityEditForm from '@/components/ui/crud/EntityEditForm.vue'
  import FilialDataService from '@/services/api/FilialDataService'

  export default {
    components: { EntityEditForm },
    data () {
      return {
        title: 'Новый регион',
        isCreate: true,
        listRouteName: 'filialsList',
        dataService: FilialDataService,
        fields: FilialDataService.getCrudFields(),
      }
    },
    methods: {
      afterCreate () {
        this.$store.dispatch('branches/fetchBranches')
      },
    },

  }
</script>
